import React from 'react';
import PropTypes from 'prop-types';

import Navigation from "../Navigation";

import styles from './index.module.scss';

export const LayoutComponent = (props) => {
    const { navData, children } = props;

    return (
        <div className={styles.wrapper}>
            <div className={styles.mainNav}>
                <Navigation navData={navData}/>
            </div>
            <div className={styles.mainContent}>
                <div className={styles.inner}>
                    {children}
                </div>
            </div>
        </div>
	);
};

LayoutComponent.propTypes = {
    navData: PropTypes.array,
    children: PropTypes.any.isRequired,
};

LayoutComponent.defaultProps = {
    navData: [
        {
            type: 'item',
            text: 'Dashboard',
            url: '/dashboard',
        },
        {
            type: 'item',
            text: 'Challenges',
            url: '/challenges',
        },
        {
            type: 'item',
            text: 'Gallery',
            url: '/gallery',
        },
    ],
};

export default (LayoutComponent);
